module.exports = __webpack_public_path__ + "img/company-illus-bg2.7aeffd8.png";